import { Eye, PenLine, Hammer, RefreshCw } from 'lucide-react';
import { WavePattern } from './WavePattern';
import { useLang } from '../../contexts/LanguageContext';

const CARD_ICONS = [Eye, PenLine, Hammer, RefreshCw];

export const BenefitsSection = () => {
  const { t } = useLang('benefits');

  return (
    <section id="benefits" className="py-24 px-4 sm:px-6 lg:px-8 bg-[#111111] relative overflow-hidden">
      <WavePattern className="inset-0 w-full h-full" opacity={0.1} />
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="h-1 w-8 bg-[#00CED1] rounded-full" />
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#00CED1]">{t.eyebrow}</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6 text-white">
              {t.title}
            </h2>
            <p className="text-lg text-white/60 mb-8">
              {t.subtitle}
            </p>
            <ul className="space-y-3">
              {(t.reasons || []).map((reason) => (
                <li key={reason} className="flex items-start gap-3 text-white/80">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#00CED1] flex-shrink-0" />
                  <span>{reason}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="grid grid-cols-2 gap-5">
            {(t.cards || []).map((card, i) => {
              const Icon = CARD_ICONS[i] || Eye;
              return (
                <div key={card.title} className="bg-white/[0.03] backdrop-blur-sm p-6 rounded-xl border border-white/[0.06] hover:border-[#00CED1]/30 transition-colors">
                  <Icon className="h-8 w-8 mb-4 text-[#00CED1]" />
                  <p className="text-2xl font-bold mb-1 text-white">{card.title}</p>
                  <p className="text-sm text-white/40">{card.sub}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
